"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconChargingKeysMultiple = function IconChargingKeysMultiple(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M20.845 8.777c4.023 4.15 2.582 11.053-2.766 13.247a8.1 8.1 0 0 1-4.608.475 8.7 8.7 0 0 0 3.585-2.513q.08-.03.163-.06c3.863-1.586 4.903-6.572 1.997-9.571l-1.098-1.133-1.07-4.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M11.017 3.647c1.123.158 1.86 1.137 1.703 2.26s-1.137 1.86-2.26 1.701C9.339 7.451 8.6 6.472 8.759 5.35s1.137-1.86 2.26-1.703m-.139.99a1.025 1.025 0 0 0-1.13.852 1.025 1.025 0 0 0 .852 1.13 1.025 1.025 0 0 0 1.13-.852 1.025 1.025 0 0 0-.852-1.13",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M11.832.732a4.84 4.84 0 0 1 4.026 3.638l1.894 7.712.063.272c1.21 5.699-3.616 10.927-9.441 10.109-5.918-.832-9.126-7.378-6.156-12.564l3.947-6.891.196-.313A4.84 4.84 0 0 1 11.038.621zm-1.073 1.87a2.84 2.84 0 0 0-2.744 1.216l-.114.184-3.947 6.891c-2.266 3.958.181 8.954 4.698 9.59 4.376.614 8.013-3.241 7.246-7.51l-.087-.414-1.896-7.712a2.84 2.84 0 0 0-2.362-2.134z"
  })));
};

export { IconChargingKeysMultiple, IconChargingKeysMultiple as default };
